export const getProviderName = (provider) => {
    switch (provider) {
        case 0:
            return "Total Processing";
            break;
        case 1:
            return "SysPay";
            break;
        case 2:
            return "Card Corp";
            break;
        case 3:
            return "SysPay2";
            break;
    }
}